import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rich-text-editor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_QuillEditor, {
      ref: "quillEditor",
      content: _ctx.content,
      "onUpdate:content": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content) = $event)),
        _ctx.onContentChange
      ],
      options: _ctx.editorOptions,
      "content-type": "html"
    }, null, 8, ["content", "options", "onUpdate:content"])
  ]))
}